export default window.__forcia__.config;



// WEBPACK FOOTER //
// ./web/WEB-INF/js/client/search/server-param.js